import React, { useEffect, useState } from "react";
import "./styles.css"
import {
  NotificationData,
  NotificationPayload,
} from "common/features/notification/notificationModels";
import { DINE_IN_NOTIFICATION_REQUEST, USER_ID } from "common/constants";
import { sendNotification } from "common/features/notification/notificationAPI";
import { toast } from "react-toastify";
import KetchupImage from "common/assets/images/ketchup-icon.png";
import SaltNPepperImage from "common/assets/images/salt-and-pepper-icon.png";
import WaterImage from "common/assets/images/water-icon.png";
import CallWaiterV2Image from "common/assets/images/waiter-icon.png";
import { useSelector } from "react-redux";
import { RootState } from "common/rootReducer";
import CloseMenuIcon from "common/assets/images/close-menu-icon.png";
import CallWaiterImage from "common/assets/images/call-waiter.png";

interface Props {
  isMenuOpen: any;
  dineInOrderId: any;
  tableData: any;
  restaurantDetails: any;
  setIsMenuOpen: any;
  isContactlessDineInOrder?: any;
}

const CallWaiter = ({
  isMenuOpen,
  dineInOrderId,
  tableData,
  restaurantDetails,
  setIsMenuOpen,
  isContactlessDineInOrder,
}: Props) => {
  const [remainingTime, setRemainingTime] = useState<number>(
    Number(localStorage.getItem("remainingTime")) || 0
  );
  const [isRunning, setIsRunning] = useState(
    remainingTime === 0 ? false : true
  );
  const [currentSelectedWaiterOption, setCurrentSelectedWaiterOption] =
    useState<WaiterOptionType>("");

  const toastId = React.useRef<any>(null);

  const notify = (message: string) =>
    (toastId.current = toast.success(message, {
      position: toast.POSITION.TOP_CENTER,
    }));

  const restaurantMenuDetailLoading = useSelector(
    (state: RootState) => state.restaurant.restaurantMenuDetailLoading
  );

  const navigation = useSelector(
    (state: RootState) => state.navigation.currentMenuOption
  );

  const getCurrentActiveWaiterIcon = () => {
    if (currentSelectedWaiterOption == "Call Waiter") {
      return CallWaiterV2Image;
    } else if (currentSelectedWaiterOption == "Ketchup - Request") {
      return KetchupImage;
    } else if (currentSelectedWaiterOption == "Salt & Pepper - Request") {
      return SaltNPepperImage;
    } else if (currentSelectedWaiterOption == "Water - Request") {
      return WaterImage;
    } else if (currentSelectedWaiterOption == "") {
      return CallWaiterImage;
    }
  };

  useEffect(() => {
    let interval: any;

    if (isRunning) {
      interval = setInterval(() => {
        setRemainingTime((prevTime) => prevTime - 1);
      }, 1000);
    }

    if (remainingTime <= 0) {
      setIsRunning(false);
      clearInterval(interval);
    }

    return () => clearInterval(interval);
  }, [isRunning, remainingTime]);

  useEffect(() => {
    localStorage.setItem("remainingTime", remainingTime);
  }, [remainingTime]);

  const startTimer = () => {
    setRemainingTime(180);
    setIsRunning(true);
  };

  const formatTime = (timeInSeconds: number) => {
    const minutes = Math.floor(timeInSeconds / 60);
    const seconds = timeInSeconds % 60;
    return `${minutes.toString().padStart(2, "0")}:${seconds
      .toString()
      .padStart(2, "0")}`;
  };
  const WaiterOptionTypes = [
    "Call Waiter",
    "Water - Request",
    "Salt & Pepper - Request",
    "Ketchup - Request",
    "",
  ] as const;
  type WaiterOptionType = typeof WaiterOptionTypes[number];
  const handleSendNoti = (requestOption: string) => {
    const data = {
      orderId: null,
      fullName: null,
      orderNo: null,
      orderTypeId: dineInOrderId,
      status: null,
      orderTime: null,
      isNew: true,
      tableName: tableData.tableName,
      request: requestOption,
      locationId: restaurantDetails?.id,
    } as NotificationData;
    const notiPayload = {
      messageType: DINE_IN_NOTIFICATION_REQUEST,
      messageData: JSON.stringify(data),
    } as NotificationPayload;
    try {
      sendNotification(restaurantDetails.id, notiPayload);
      setIsMenuOpen(false);
      setCurrentSelectedWaiterOption(requestOption as WaiterOptionType);
      startTimer();
      notify(requestOption + " sent successfully!");
    } catch (error) {
      // console.log(error, " ::: error");
    }
  };

  //THROTTLING TO BE ADDED
  // const throttledOnSubmit = (requestOption : string)=> throttle(handleSendNoti(requestOption), 3000);

  const handleSelectOption = (requestOption: string) => {
    // setRequestOption(requestOption);
    handleSendNoti(requestOption);
  };

  const handleCallWaiter = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  return (
    <div className={navigation === 'Order' || navigation === 'Cart' ? "navOrder" : ""}>
      {isMenuOpen && (
        <>
          {/* <div
            id="menu-call-waiter-container"
            className="call-Ketchup"
            onClick={() => handleSelectOption("Ketchup - Request")}
          >
            <p className="manu-labelText">{"Ketchup"}</p>
            <div id="call-waiter-btn">
              <span>
                <img
                  src={KetchupImage}
                  alt="loading"
                  className="restaurant-menuImage img-size"
                />
              </span>
            </div>
          </div> */}
          <div
            id="menu-call-waiter-container"
            className="call-Salt"
            onClick={() => handleSelectOption("Salt & Pepper - Request")}
          >
            <p className="manu-labelText">{"Salt & Pepper"}</p>
            <div id="call-waiter-btn">
              <span>
                <img
                  src={SaltNPepperImage}
                  alt="loading"
                  className="restaurant-menuImage img-size"
                />
              </span>
            </div>
          </div>
          <div
            id="menu-call-waiter-container"
            className="Water"
            onClick={() => handleSelectOption("Water - Request")}
          >
            <p className="manu-labelText">Water</p>
            <div id="call-waiter-btn">
              <span>
                <img
                  src={WaterImage}
                  alt="loading"
                  className="restaurant-menuImage img-size"
                />
              </span>
            </div>
          </div>
          <div
            id="menu-call-waiter-container"
            className="Call-waiter"
            onClick={() => handleSelectOption("Call Waiter")}
          >
            <p className="manu-labelText">Call waiter</p>
            <div id="call-waiter-btn">
              <span>
                <img
                  src={CallWaiterV2Image}
                  alt="loading"
                  className="restaurant-menuImage img-size"
                />
              </span>
            </div>
          </div>
        </>
      )}
      {isContactlessDineInOrder && !restaurantMenuDetailLoading && (
        <div id="menu-call-waiter-container" 
            className="close-btn-container"
        >
          <button
            id="close-btn"
            className="call-waiter-button"
            disabled={isRunning}
            onClick={() => handleCallWaiter()}
          >
            <img
              src={isMenuOpen ? CloseMenuIcon : getCurrentActiveWaiterIcon()}
              alt="loading"
              className={`restaurant-menuImage ${isMenuOpen ? "menuImage-open-width" : "menuImage-close-width"}`}

            />
            {isRunning && (
              <div className="call-waiter-timer">
                {formatTime(remainingTime)}
              </div>
            )}
          </button>
        </div>
      )}
    </div>
  );
};

export default CallWaiter;
